import { webfontBaseUrl } from 'elements/icon/font-awesome/v6.5.1/webfont-base-url.js'
import { css, CSSResult } from 'lit'


/*!
 * Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2023 Fonticons, Inc.
 */
export const faLight: CSSResult = css`
  :root, :host {
    --fa-style-family-classic: 'Font Awesome 6 Pro';
    --fa-font-light: normal 300 1em/1 'Font Awesome 6 Pro';
  }
  
  @font-face {
    font-family: 'Font Awesome 6 Pro';
    font-style: normal;
    font-weight: 300;
    font-display: block;
    src: url("${webfontBaseUrl}/fa-light-300.woff2") format("woff2"), url("${webfontBaseUrl}/fa-light-300.ttf") format("truetype");
  }`

// Split to allow the @font-face to be loaded at the document level,
// while the class styles are loaded at the element level.
export const faLightClass: CSSResult = css`
  .fal,
  .fa-light {
    font-weight: 300;
  }`
